import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { getSalesByTransType } from "../../../services/SalesApiServices";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import dayjs from "dayjs";
import moment from "moment";

// const getFooterTotals = (data, columns, currfmt = 2) => {
//   const totals = {};
//   columns.forEach((col) => {
//     if (
//       col.dataIndex &&
//       data.length > 0 &&
//       !isNaN(Number(data[0][col.dataIndex]))
//     ) {
//       totals[col.dataIndex] = data
//         .reduce((sum, record) => sum + Number(record[col.dataIndex] || 0), 0)
//         .toFixed(currfmt);
//     }
//   });
//   return totals;
// };

const SalesReport1 = ({ data, Reportcolumns, currfmt , summary,pagination}) => {
  const [searchText, setSearchText] = useState("");
  const [salesData, setsalesData] = useState([]);
  const [filteredSalesData, setfilteredSalesData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);

  const MySwal = withReactContent(Swal);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    handlesalesData();
  }, [branch]);

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 0);
      setsalesData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
      MySwal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch sales data.",
      });
    }
  };

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  return (
    <div>
      <div className="mb-3"></div>
      <Table
        columns={Reportcolumns}
        dataSource={data}
        summary ={summary }
          pagination={pagination}
        // summary={() => {
        //   const totals = getFooterTotals(data, Reportcolumns, currfmt);
        //   return (
        //     <Table.Summary.Row>
        //       {Reportcolumns.map((col) => (
        //         <Table.Summary.Cell key={col.dataIndex}>
        //           <b>{totals[col.dataIndex] || ""}</b>
        //         </Table.Summary.Cell>
        //       ))}
        //     </Table.Summary.Row>
        //   );
        // }}
      />
    </div>
  );
};

export default SalesReport1;
